import { TagType } from '@gyym/sdk'

import { useTags } from './useTags'

export const useTag = (tagValue?: string, type?: TagType) => {
  const { data: tags, ...rest } = useTags(type ? { type } : undefined)

  return {
    data: tags?.find((t) => t.value === tagValue),
    ...rest,
  }
}
